import { appLocalStorage } from '@/app/shared/services';
import * as getterTypes from './types/getter_types';

export default {
  [getterTypes.LOADING]: (state) => state.loading,
  [getterTypes.DATA]: (state) => state.data,
  [getterTypes.ERROR]: (state) => state.error,
  [getterTypes.SELECTED]: (state) => state.selected ?? appLocalStorage.getItem('ingredient'),
  [getterTypes.CATEGORY]: (state) => state.category,
};
